export {default} from './IntegrationInstructions';



// WEBPACK FOOTER //
// ./src/pages/IntegrationInstructions/index.ts